import classNames from 'classnames'
import React from 'react'
import {useSettings} from '../../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../../settingsParams'
import {useWidgetState} from '../../../../hooks/state-provider'
import {getComponentConfig} from '../../../../selectors/settings'
import {
  getHorizontalDividerHeight,
  getHorizontalDividerWidth,
  isHorizontalDividersVisible,
  isLabelsVisible,
  isOnImageLayout,
} from '../../../../selectors/single-settings'
import sc from '../../../classes.scss'
import {Divider} from '../../divider'
import s from '../date-location.scss'
import {PresentationProps} from './interfaces'

export const Presentation = ({text, text2, dataHook, settingsKey}: PresentationProps) => {
  const {get} = useSettings()
  const title = get(settingsParams[settingsKey])

  const titleVisible = useWidgetState(isLabelsVisible)
  const dividerVisible = useWidgetState(isHorizontalDividersVisible)
  const componentConfig = useWidgetState(getComponentConfig)
  const dividerWidth = getHorizontalDividerWidth(componentConfig)
  const dividerHeight = getHorizontalDividerHeight(componentConfig)
  const onImage = useWidgetState(isOnImageLayout)

  return (
    <div data-hook={`${dataHook}-container`} className={classNames({[s.noInnerDivider]: !dividerVisible})}>
      {titleVisible && (
        <div
          className={classNames(s.title, sc.textNoMargin, {[s.onImageLabel]: onImage})}
          data-hook={`${dataHook}-title`}
        >
          {title}
        </div>
      )}
      {titleVisible && dividerVisible && (
        <div className={s.innerDivider} data-hook={`${dataHook}-divider`}>
          <Divider width={dividerWidth} height={dividerHeight} />
        </div>
      )}
      <div className={classNames(s.text, sc.textNoMargin, sc.preWrap, {[s.onImageText]: onImage})}>
        <div className={s.value} data-hook={`${dataHook}-text`}>
          {text || ''}
          {text && text2 ? ', ' : ''}
        </div>
        {text2 && (
          <div className={s.value} data-hook={`${dataHook}-additional-text`}>
            {text2}
          </div>
        )}
      </div>
    </div>
  )
}
